import { DateTimeFormatter, UnitFormatter } from '../../../formatters';
import commonFormatter from '../../../formatters/common-formatter';
import useDebugFeatures from '../../../hooks/use-debug-features';
import { RouteFlownPointTooltipData } from '../../../services/map-interaction-service';

export function FlownPointTooltip(props: { info: RouteFlownPointTooltipData }) {
    const context = props.info;
    const debug = useDebugFeatures();

    return (
        <div
            style={{
                maxWidth: 250,
                backgroundColor: 'var(--bg-color)'
            }}>
            {context.items.map((x, i) => (
                <div key={i} className="p-2" style={{ fontSize: 12 }}>
                    <div className="d-flex gap-2">
                        <div>{UnitFormatter.formatSpeed(x.speed) || '- kts'}</div>
                        <div>{UnitFormatter.formatAltitude(x.altitude) || '- ft'}</div>
                    </div>
                    <div>
                        {commonFormatter.formatFeedId(x.feedId)}
                        {debug && x.feedId !== null && <span> ({x.feedId})</span>}
                    </div>
                    <div>{DateTimeFormatter.formatTime(x.time, 'hms')}</div>
                </div>
            ))}
        </div>
    );
}
